import { render } from "./HangTagContainer.vue?vue&type=template&id=31665719"
import script from "./HangTagContainer.vue?vue&type=script&lang=js"
export * from "./HangTagContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__